import { render } from "./MultiValueTextBoxWithFallback.vue?vue&type=template&id=47b28090"
import script from "./MultiValueTextBoxWithFallback.vue?vue&type=script&lang=js"
export * from "./MultiValueTextBoxWithFallback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__